import React, { Component } from "react";
import PropTypes from "prop-types";

// tree data example
/*
const tree = [
  {
    // you may include any data as you wish
    // optionally we read isCollapsed and children field
    label: "1",
    isCollapsed: false,
    children: [
      {
        label: "1-1"
      },
      {
        label: "1-2"
      }
    ]
  },
  {
    label: "2",
    isCollapsed: false,
    children: [
      {
        label: "2-1"
      }
    ]
  }
];
*/

export default class TreeView extends Component {
  static propTypes = {
    tree: PropTypes.arrayOf(
      PropTypes.shape({
        isCollapsed: PropTypes.bool,
        children: PropTypes.array
      })
    ),
    renderNode: PropTypes.func.isRequired,
    onChange: PropTypes.func
  };

  static defaultProps = { tree: [] };

  render() {
    const { tree } = this.props;

    // track node count
    this.count = 0;
    const renders = [];
    for (const node of tree) {
      renders.push(this.renderChild(0, node));
    }
    return renders;
  }

  renderChild = (level, node) => {
    const { renderNode } = this.props;
    const renders = [];

    // increase render count
    this.count++;

    // render this node
    renders.push(
      <div key={this.count}>{renderNode(level, node, this.notifyChange)}</div>
    );

    // and then render children
    if (!node.isCollapsed && node.children) {
      for (const childNode of node.children) {
        renders.push(this.renderChild(level + 1, childNode));
      }
    }
    return renders;
  };

  notifyChange = () => {
    const { tree, onChange } = this.props;
    if (onChange) onChange(tree);
  };
}



// WEBPACK FOOTER //
// ./src/module-common/TreeView.js